/**
 * Миксин делает возможность закрывания модальных окон по нажатию ESC
 *
 */
export const closeModalByEsc = {
    methods: {
        hideModal() {},
        escapePressed(e) {
            if (e.keyCode == 27 || e.key == 'Escape' || e.code == 'Escape') {
                this.hideModal();
            };
            return false;
        },
    },
    // created() и beforeDestroy() в компонентах будут работать как обычно
    created() {
        document.addEventListener('keydown', this.escapePressed);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.escapePressed);
    },
};
